const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    xmlns: "http://www.w3.org/2000/svg",
    height: 18,
    id: "screenshot-7f924fc0-c361-805a-8007-43f09ce03e60",
    viewBox: "951 71 29 18",
    style: {
      WebkitPrintColorAdjust: ":exact"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "shape-7f924fc0-c361-805a-8007-43f09ce03e60",
    style: {
      fill: "#000000"
    },
    rx: 0,
    ry: 0
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape-7f924fc0-c361-805a-8007-43f09ce03e61",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-7f924fc0-c361-805a-8007-43f09ce03e61"
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    x: 951,
    y: 71,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    width: 29,
    height: 18,
    fill: "none",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-7f924fc0-c361-805a-8007-43f09ce03e62"
  }, /*#__PURE__*/React.createElement("defs", {
    style: {
      fill: "#000000"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "shape-7f924fc0-c361-805a-8007-43f09ce03e63",
    style: {
      fill: "#000000"
    },
    rx: 0,
    ry: 0
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape-7f924fc0-c361-805a-8007-43f09ce03e64"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-7f924fc0-c361-805a-8007-43f09ce03e64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M951,79.11396026611328L979.294189453125,79.11396026611328",
    style: {
      fill: "none",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      strokeMiterlimit: 10
    },
    id: "strokes-0f2da47a-c2a0-8098-8007-7217ddd3e05c-7f924fc0-c361-805a-8007-43f09ce03e64",
    className: "strokes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "stroke-shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M951,79.11396026611328L979.294189453125,79.11396026611328",
    style: {
      fill: "none",
      fillOpacity: "none",
      strokeWidth: 1,
      stroke: "#ffffff",
      strokeOpacity: 1
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "shape-7f924fc0-c361-805a-8007-43f09ce03e65"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-7f924fc0-c361-805a-8007-43f09ce03e65"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M970.9954833984375,88.67145538330078L979.294189453125,79.11396026611328L970.41064453125,71.36834716796875",
    style: {
      fill: "none",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      strokeMiterlimit: 10
    },
    id: "strokes-0f2da47a-c2a0-8098-8007-7217ddd3e05d-7f924fc0-c361-805a-8007-43f09ce03e65",
    className: "strokes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "stroke-shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M970.9954833984375,88.67145538330078L979.294189453125,79.11396026611328L970.41064453125,71.36834716796875",
    style: {
      fill: "none",
      fillOpacity: "none",
      strokeWidth: 1,
      stroke: "#ffffff",
      strokeOpacity: 1
    }
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/ArrowIcon.578d2f8488e83bda258708e2f5b98b1a.svg";
export { ForwardRef as ReactComponent };